import { ApiResponse } from "helpers/fetch-wrapper";
import { ProductRequests } from "queries/product-queries";
import React from "react";

interface Product {
    user_id: string
}

export async function productCreateAction(product: any) {
    const response = await ProductRequests.createProduct(product);
    const data: Product = await response.json();

    const apiResponse: ApiResponse<Product> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 201 ? null : data['message'],
    }

    return apiResponse
}

export async function productUpdateAction(productId: string, product: any) {
    try {
        const response = await ProductRequests.updateProduct(productId, product);
        const data: Product = await response.json();

        const apiResponse: ApiResponse<Product> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 201 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<Product> = {
            body: null,
            message: 'Failed to update product, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}

export async function productDeleteAction(productId: string) {
    try {
        const response = await ProductRequests.deleteProduct(productId);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: null,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to delete product, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}

export async function productSetAvailabilityAction(productIds: string[], isAvailable: boolean) {
    try {

        const _data = {
            "productIds": productIds,
            "isAvailable": isAvailable
        }

        const response = await ProductRequests.setAvailability(_data);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: null,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to set product availability, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}

export type ProductList = {
    id: string;
    name: string;
    price: number;
    category: string;
    description: string;
    featured: boolean;
    today_special: boolean;
    available: boolean;
    image_url: string | null;
    action: React.ReactNode;
}

export async function getProductDataAction() {
    try {
        const response = await ProductRequests.getProducts();
        const data: ProductList[] = await response.json();

        const apiResponse: ApiResponse<ProductList[]> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        // console.log(apiResponse)

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<ProductList[]> = {
            body: [],
            message: 'Failed to ge products, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}